import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  saveClient,
} from '../../actions/advisor';
import s from './Step2.css';

class Step2 extends PureComponent {

  constructor(props) {
    super(props);
    const newClient = Object.assign({}, this.props.client);
    this.state = {
      client: newClient,
      isDirty: false,
    };
  }

  // update the value to state for form text fields
  editClientFormChange = (event) => {
    const target = event.target;
    const {
      name,
      value,
     } = target;
    const newClient = Object.assign({}, this.state.client);
    newClient[name] = value;
    this.setState(Object.assign({}, this.state, {
      client: newClient,
      isDirty: true,
    }));
  }

  // save client with current saved state values
  saveClient = (event) => {
    const {
      client,
    } = this.state;
    event.preventDefault();
    const newClient = Object.assign({}, this.props.client);
    newClient.birthYear = client.birthYear;
    newClient.retireAge = client.retireAge;
    newClient.currentSavings = parseInt(client.currentSavings.toString().replace(/,/g, ''));
    newClient.monthlySavings = parseInt(client.monthlySavings.toString().replace(/,/g, ''));
    newClient.retireMonthlyIncome = parseInt(client.retireMonthlyIncome.toString().replace(/,/g, ''));
    this.props.saveClient(newClient).then(() => {
      this.setState(Object.assign({}, this.state, {
        isDirty: false,
      }));
      this.props.closeStep();
    });
  }

  resetClient = (event) => {
    event.preventDefault();
    const newClient = Object.assign({}, this.props.client);
    this.setState(Object.assign({}, this.state, {
      client: newClient,
      isDirty: false,
    }));
  }

  render() {
    const {
      client,
    } = this.state;
    return (
		<React.Fragment>
			<div className="row" style={{marginTop:'60px'}}>
      	<div className={`col-md-6`}>
					<div className={s.formTitle}>Profile</div>
      	</div>
    	</div>
			<div className="row" style={{marginTop:'15px'}}>
				<div className={`col-md-4`}>
					<label htmlFor="birthYear" className={s.formLabel}>Birth Year</label>
					<input
						style={{height:'40px', paddingTop:'8px'}}
						name="birthYear"
						value={client.birthYear}
						onChange={this.editClientFormChange}
						type="text"
						className={`form-control ${s.formControl}`}
						placeholder=""
					/>
        </div>
        <div className={`col-md-4`}>
					<label htmlFor="retireAge" className={s.formLabel}>Retirement Age</label>
					<input
						style={{height:'40px', paddingTop:'8px'}}
						name="retireAge"
						value={client.retireAge}
						onChange={this.editClientFormChange}
						type="text"
						className={`form-control ${s.formControl}`}
						placeholder=""
					/>
        </div>
        <div className={`col-md-4`}>
					<label htmlFor="currentSavings" className={s.formLabel}>$ Current Savings</label>
					<input
						style={{height:'40px', paddingTop:'8px'}}
						name="currentSavings"
						value={client.currentSavings.toLocaleString()}
						onChange={this.editClientFormChange}
						type="text"
						className={`form-control ${s.formControl}`}
						placeholder=""
					/>
        </div>
			</div>
			<div className="row" style={{marginTop:'30px'}}>
        <div className={`col-md-4`}>
					<label htmlFor="monthlySavings" className={s.formLabel}>$ Pre-Retirement Yearly Contribution</label>
					<input
						style={{height:'40px', paddingTop:'8px'}}
						name="monthlySavings"
						value={client.monthlySavings.toLocaleString()}
						onChange={this.editClientFormChange}
						type="text"
						className={`form-control ${s.formControl}`}
						placeholder=""
					/>
        </div>
        <div className={`col-md-4`}>
					<label htmlFor="retireMonthlyIncome" className={s.formLabel}>$ Preferred Retirement Yearly Income</label>
					<input
						style={{height:'40px', paddingTop:'8px'}}
						name="retireMonthlyIncome"
						value={client.retireMonthlyIncome.toLocaleString()}
						onChange={this.editClientFormChange}
						type="text"
						className={`form-control ${s.formControl}`}
						placeholder=""
					/>
        </div>
			</div>
      <div className="row" style={{marginTop:'60px'}}>
      	<div className={`col-md-12`} style={{textAlign:'center'}}>
					<div className={s.saveButton} onClick={this.saveClient}>SAVE</div>
					<div className={s.cancelButton} onClick={this.resetClient}>CANCEL</div>
      	</div>
    	</div>
		</React.Fragment>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  saveClient,
})(Step2);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/Step2.js